import { useDialog } from "@shared/features/dialog/useDialog";
import { SupportDialogTypes } from "../../support.types";
import { SupportTicketFormContainer } from "../SupportTicketForm/SupportTicketFormContainer";
import { SupportSearchFormContainer } from "../SupportSearchForm/SupportSearchFormContainer";

export function SupportDialogs() {
  const { activeDialog } = useDialog();

  if (!["supportTicket", "supportSearch"].includes(activeDialog || "")) {
    return null;
  }

  switch (activeDialog as SupportDialogTypes) {
    case "supportTicket":
      return <SupportTicketFormContainer />;
    case "supportSearch":
      return <SupportSearchFormContainer />;
    default:
      return null;
  }
}

export default SupportDialogs;
